<template>
  <div class="material-library-page">
    <div class="material-library-container" style="padding-bottom: 60px;">
      <div class="title-bg">物料库</div>
      <!-- 搜索区域 -->
      <v-card class="search-card">
        <v-card-text>
          <v-row class="align-center">
            <v-col cols="12" sm="4">
              <v-text-field
                v-model="searchForm.keyword"
                label="关键字搜索"
                persistent-placeholder
                prepend-inner-icon="mdi-magnify"
                variant="outlined"
                hide-details
                density="compact"
                clearable
                class="search-input"
                placeholder="物料名称/规格/大类/小类/编码/备注"
                @keyup.enter="handleSearch"
                @click:clear="handleSearch"
              />
            </v-col>
            <v-col cols="12" sm="5">
              <div class="d-flex gap-2">
                <v-btn
                  color="primary"
                  variant="flat"
                  @click="handleSearch"
                  class="search-btn"
                  density="comfortable"
                >
                  查询
                </v-btn>
                <v-btn
                  color="primary"
                  variant="flat"
                  @click="handleReset"
                  class="search-btn"
                  density="comfortable"
                >
                  重置
                </v-btn>
              </div>
            </v-col>
            <v-col cols="12" sm="3" v-if="userStore.userInfo?.auths.includes('jf_goods')">
              <div class="d-flex justify-end">
                <v-btn
                  color="primary"
                  variant="flat"
                  @click="handleAdd"
                  class="search-btn"
                  density="comfortable"
                >
                  新增物料
                </v-btn>
                <v-btn
                  color="primary"
                  variant="flat"
                  class="ml-4 search-btn"
                  @click="importMaterial"
                  density="comfortable"
                >
                  导入物料
                </v-btn>
                <v-btn
                  color="primary"
                  variant="flat"
                  class="ml-4 search-btn"
                  @click="downloadMaterial"
                  density="comfortable"
                >
                  下载物料模板
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- 表格区域 -->
      <v-card class="table-card">
        <v-card-text class="pa-0">
          <v-table class="material-table" hover>
            <thead>
              <tr>
                <th v-for="header in headers" :key="header.key" :class="['text-' + header.align]" :style="{ width: header.width }">
                  {{ header.title }}
                </th>
                <!-- <th v-if="isSelectMode" class="text-center" style="width: 30px;">
                  <v-checkbox
                    :model-value="isAllSelected"
                    :indeterminate="isIndeterminate"
                    hide-details
                    density="compact"
                    @update:model-value="toggleSelectAll"
                  />
                </th> -->
              </tr>
            </thead>
            <tbody>
              <tr v-if="loading" class="text-center">
                <td :colspan="isSelectMode ? headers.length + 1 : headers.length" class="py-8">
                  <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  <div class="mt-2">加载中...</div>
                </td>
              </tr>
              <tr v-else-if="materialList.length === 0" class="text-center">
                <td :colspan="isSelectMode ? headers.length + 1 : headers.length" class="py-8">暂无数据</td>
              </tr>
              <template v-else>
                <tr v-for="(item, index) in materialList" :key="item.id || index" :class="{ 'selected-row': isSelected(item) }">
                  <!-- 编码 -->
                  <td class="text-center">
                    {{ item.materialCode }}
                  </td>
                  <!-- 物料名称 -->
                  <td class="text-center">
                    {{ item.materialName }}
                    <!-- <v-textarea
                      v-if="userStore.userInfo?.auths.includes('jf_goods')"
                      v-model="item.materialName"
                      variant="outlined"
                      density="compact"
                      hide-details
                      rows="1"
                      auto-grow
                      resize
                      @input="debouncedSave(item, index)"
                    ></v-textarea>
                    <template v-else>{{ item.materialName }}</template> -->
                  </td>
                  <!-- 规格 -->
                  <td class="text-center">
                    {{ item.specDesc || '/' }}
                    <!-- <v-textarea
                      v-if="userStore.userInfo?.auths.includes('jf_goods')"
                      v-model="item.specDesc"
                      variant="outlined"
                      density="compact"
                      hide-details
                      rows="1"
                      auto-grow
                      resize
                      @input="debouncedSave(item, index)"
                    ></v-textarea>
                    <template v-else>{{ item.specDesc }}</template> -->
                  </td>
                  <!-- 备注 -->
                  <td class="text-center">
                    {{ item.materialRemark || '/' }}
                    <!-- <v-textarea
                      v-if="userStore.userInfo?.auths.includes('jf_goods')"
                      v-model="item.materialRemark"
                      variant="outlined"
                      density="compact"
                      hide-details
                      rows="1"
                      auto-grow
                      resize
                      @input="debouncedSave(item, index)"
                    ></v-textarea>
                    <template v-else>{{ item.materialRemark || '/' }}</template> -->
                  </td>
                  <!-- 单位 -->
                  <td class="text-center">
                    {{ item.materialUnit || '/' }}
                    <!-- <v-text-field
                      v-if="userStore.userInfo?.auths.includes('jf_goods')"
                      v-model="item.materialUnit"
                      variant="outlined"
                      density="compact"
                      hide-details
                      @input="debouncedSave(item, index)"
                    ></v-text-field>
                    <template v-else>{{ item.materialUnit || '/' }}</template> -->
                  </td>
                  <!-- 大类 -->
                  <td class="text-center">
                    {{ item.bigClass || '/' }}
                    <!-- <v-select
                      v-if="userStore.userInfo?.auths.includes('jf_goods')"
                      v-model="item.bigClass"
                      :items="bigClassOptions"
                      item-title="title"
                      item-value="value"
                      variant="outlined"
                      density="compact"
                      hide-details
                      @update:model-value="handleChangeBigClass(item, index)"
                    ></v-select>
                    <template v-else>{{ item.bigClass || '/' }}</template> -->
                  </td>
                  <!-- 小类 -->
                  <td class="text-center">
                    {{ item.materialType || '/' }}
                    <!-- <v-select
                      v-if="userStore.userInfo?.auths.includes('jf_goods')"
                      v-model="item.materialType"
                      :items="item.bigClass ? getMaterialTypeOptions(item.bigClass) : []"
                      item-title="title"
                      item-value="value"
                      variant="outlined"
                      density="compact"
                      hide-details
                      @update:model-value="debouncedSave(item, index)"
                    ></v-select>
                    <template v-else>{{ item.materialType || '/' }}</template> --> 
                  </td>
                  <!-- 操作 -->
                  <td class="text-center">
                    <!-- v-if="userStore.userInfo?.auths.includes('jf_goods')" -->
                    <div style="display: flex;justify-content: center;align-items: center;">
                      <v-btn
                        color="error"
                        variant="tonal"
                        size="small"
                        style="margin-right: 8px;"
                        @click="handleDelete(item, index)"
                      >
                        删除
                      </v-btn>
                      <v-btn
                        color="primary"
                        size="small"
                        variant="flat"
                        class="mr-2"
                        @click="handleEdit(item)"
                      >
                        编辑
                      </v-btn>
                      <!-- 选择框 -->
                      <template v-if="isSelectMode">
                        <v-checkbox
                          :model-value="isSelected(item)"
                          hide-details
                          density="compact"
                          @update:model-value="toggleSelect(item)"
                        />
                      </template>
                    </div>
                    <!-- <v-btn
                      color="primary"
                      size="small"
                      variant="flat"
                      class="mr-2"
                      @click="handleCreatePurchaseOrder(item)"
                    >
                      发起请购
                    </v-btn> -->
                  </td>
                </tr>
              </template>
            </tbody>
          </v-table>

          <!-- 分页区域 -->
          <div class="custom-pagination d-flex align-center justify-space-between">
            <div class="pagination-info">共 {{ total }} 条记录</div>
            
            <div class="d-flex align-center">
              <div class="pagination-controls">
                <v-btn
                  icon="mdi-chevron-double-left"
                  variant="text"
                  density="comfortable"
                  :disabled="currentPage === 1"
                  @click="currentPage = 1"
                  class="pagination-btn"
                />
                <v-btn
                  icon="mdi-chevron-left"
                  variant="text"
                  density="comfortable"
                  :disabled="currentPage === 1"
                  @click="currentPage--"
                  class="pagination-btn"
                />
                <span class="pagination-text mx-2">{{ currentPage }} / {{ totalPages }}</span>
                <v-btn
                  icon="mdi-chevron-right"
                  variant="text"
                  density="comfortable"
                  :disabled="currentPage === totalPages"
                  @click="currentPage++"
                  class="pagination-btn"
                />
                <v-btn
                  icon="mdi-chevron-double-right"
                  variant="text"
                  density="comfortable"
                  :disabled="currentPage === totalPages"
                  @click="currentPage = totalPages"
                  class="pagination-btn"
                />
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>

      <div class="form-actions">
        <template v-if="isSelectMode">
          <!-- <v-btn color="error" variant="tonal" @click="cancelSelectMode" class="mr-4">取消选择</v-btn> -->
          <v-btn color="primary" variant="flat" @click="confirmPurchaseOrder" :disabled="selectedMaterials.length === 0">
            确认请购 ({{ selectedMaterials.length }})
          </v-btn>
        </template>
        <template v-else>
          <v-btn color="primary" variant="flat" @click="handlePurchaseOrder">发起请购</v-btn>
        </template>
      </div>
      <!-- 添加/编辑物料对话框 -->
      <v-dialog v-model="showAddDialog" max-width="850" max-height="600px" persistent>
        <v-card class="delete-confirm-dialog">
          <v-card-title class="d-flex justify-space-between align-center">
            <span>{{ isEditMode ? '编辑物料' : '添加物料' }}</span>
            <v-btn
              icon="mdi-close"
              variant="text"
              @click="closeAddDialog"
            />
          </v-card-title>
          <v-card-text style="display: flex;gap: 10px;align-items: flex-start;">
            <!-- <div>
              <img 
                v-if="customMaterialImageUrls && customMaterialImageUrls.length > 0"
                :src="customMaterialImageUrls[0]?.url"
                style="width: 80px;"
                alt="物料图" 
                class="material-image"
              >
              <div v-else class="no-img" style="width: 80px;height: 80px;line-height: 80px;cursor: pointer;" @click.stop="handleNewImageUpload">
                <img src="@/assets/uploadIcon.png" alt="上传" class="img-icon-one" title="上传图片" />
              </div>
            </div> -->
            <v-textarea style="width: 200px;" auto-grow resize v-model="customMaterialName" rows="1" label="物料名称" persistent-placeholder variant="outlined" density="compact" hide-details @input="debouncedLoadMaterialNameList" ></v-textarea> 
            <v-textarea style="width: 200px;" auto-grow resize v-model="customMaterialSpecDesc" rows="1" label="规格" persistent-placeholder variant="outlined" density="compact" hide-details ></v-textarea>
            <v-textarea style="width: 200px;" auto-grow resize v-model="customMaterialRemark" rows="1" label="备注" persistent-placeholder variant="outlined" density="compact" hide-details ></v-textarea>
            <v-text-field style="width: 80px;" v-model="customMaterialUnit" label="单位" persistent-placeholder variant="outlined" density="compact" hide-details />
            <v-select
              label="大类"
              persistent-placeholder
              style="width: 100px;"
              v-model="customMaterialBigClass"
              :items="bigClassOptions"
              item-title="title"
              item-value="value"
              variant="outlined"
              density="compact"
              hide-details
              @update:model-value="handleChangeCustomBigClass()"
            ></v-select>
            <v-select
              label="小类"
              persistent-placeholder
              style="width: 140px;"
              v-model="customMaterialType"
              :items="customMaterialBigClass ? getMaterialTypeOptions(customMaterialBigClass) : [{ title: '请先选大类', value: '', disabled: true }]"
              item-title="title"
              item-value="value"
              variant="outlined"
              density="compact"
              hide-details
            ></v-select>
            <!-- <v-text-field style="width: 80px;" v-model="customMaterialPrice" label="单价" persistent-placeholder variant="outlined" density="compact" hide-details /> -->
          </v-card-text>
          <v-card-actions>
            <div class="d-flex correlate-btn">
              <v-btn color="error" variant="tonal" @click="closeAddDialog">取消</v-btn>
              <v-btn color="primary" variant="flat" @click="handleAddMaterialToBank">确定</v-btn>
            </div>
          </v-card-actions>
          <v-card-text>
            <span v-if="materialNameList.length > 0" style="color: #fff;opacity: 1;font-size: 18px;">相似物料</span>
            <v-list class="material-name-list" style="background: #2B2D33;max-height: 300px;overflow-y: auto;">
              <v-list-item v-for="item in materialNameList" :key="item.id">
                <v-list-item-title style="-webkit-line-clamp:none;color: #fff;width: 210px;word-break: break-all;white-space: break-spaces;">{{ item.materialName }}</v-list-item-title>
                <v-list-item-subtitle style="-webkit-line-clamp:none;color: #fff;opacity: 1;width: 200px;word-break: break-all;white-space: break-spaces;">{{ item.specDesc || '/' }}</v-list-item-subtitle>
                <v-list-item-subtitle style="-webkit-line-clamp:none;color: #fff;opacity: 1;display: block;width: 210px;word-break: break-all;white-space: break-spaces;">{{ item.materialRemark || '/' }}</v-list-item-subtitle>
                <v-list-item-subtitle style="-webkit-line-clamp:none;color: #fff;opacity: 1;width: 80px;">{{ item.materialUnit || '/' }}</v-list-item-subtitle>
                <v-list-item-subtitle style="-webkit-line-clamp:none;color: #fff;opacity: 1;width: 90px;">{{ item.bigClass || '/' }}</v-list-item-subtitle>
                <v-list-item-subtitle style="-webkit-line-clamp:none;color: #fff;opacity: 1;width: 100px;">{{ item.materialType || '/' }}</v-list-item-subtitle>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-dialog>
      
      <!-- 上传对话框 -->
      <UploadImgDialog
        v-model="showUploadDialog"
        mode="new"
        type="image"
        @upload="handleNewImageUploadSuccess"
      />

      <!-- 导入物料excel -->
      <v-dialog v-model="importExcelDialogOpen" max-width="500">
        <ImportExcel
          accept=".xls,.xlsx"
          icon="mdi-file-document"
          :type="importExcelTypeKind"
          @uploadExcel="handleImportExcel"
          @importStart="handleImportStart"
          @close="importExcelDialogOpen = false"
        />
      </v-dialog>
      <!-- 公共Loading组件 -->
      <div v-if="showCommonLoading" class="common-loading-overlay">
        <div class="common-loading-container">
          <div class="common-loading-spinner"></div>
          <p class="common-loading-text">{{ commonLoadingText || '加载中...' }}</p>
        </div>
      </div>
      <!-- 删除确认对话框 -->
      <v-dialog v-model="deleteDialog" max-width="400">
        <v-card class="delete-dialog">
          <v-card-title class="text-h5">
            确认删除
          </v-card-title>
          <v-card-text>
            确定要删除物料 "{{ selectedMaterial?.materialName }}" 吗？
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="error"
              variant="tonal"
              @click="deleteDialog = false"
            >
              取消
            </v-btn>
            <v-btn
              color="primary"
              variant="flat"
              @click="confirmDelete"
              :loading="deleteLoading"
            >
              确认删除
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- 发起请购对话框 -->
      <v-dialog
        v-model="showPurchaseOrderDialog"
        max-width="1200"
        max-height="74vh"
        persistent
      >
        <v-card class="purchase-dialog">
          <v-card-title class="d-flex justify-space-between align-center">
            <span>{{ purchaseOrderData.id ? '修改请购' : '发起请购' }}</span>
            <v-btn
              icon="mdi-close"
              variant="text"
              @click="closePurchaseOrderDialog"
            />
          </v-card-title>
          <v-card-text>
            <v-form ref="purchaseOrderForm" v-model="purchaseOrderValid">
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field v-model="purchaseOrderData.contractNo" label="合同号" persistent-placeholder variant="outlined" density="compact" hide-details />
                </v-col>
                <v-col cols="12" md="6">
                  <v-select v-model="purchaseOrderData.warehouse" :items="formattedWarehouseList" item-title="warehouseName" item-value="warehouseAddress" label="送货地址" placeholder="请选择送货地址" persistent-placeholder variant="outlined" density="compact" hide-details="auto" return-object>
                    <template v-slot:item="{ props, item }">
                      <v-list-item v-bind="{ ...props, title: undefined }">
                        <div>
                          <div class="text-body-2">{{ item.raw.warehouseName }}</div>
                          <div class="text-caption text-grey" v-if="item.raw.warehouseAddress">地址: {{ item.raw.warehouseAddress }}</div>
                        </div>
                      </v-list-item>
                    </template>
                  </v-select>
                </v-col>
              </v-row>
              <!-- 物料列表 -->
              <div class="material-purchase-list">
                <div class="material-purchase-body">
                  <div 
                    v-for="(material, index) in purchaseOrderMaterials" 
                    :key="material.id || index"
                    class="material-purchase-item"
                  >
                    <div class="item-content" style="width: 25%;">
                      <div class="material-name" style="text-align: left;">{{ material.materialName }}</div>
                      <div class="material-spec" style="text-align: left;">{{ material.specDesc }}</div>
                      <div class="material-code" style="text-align: left;">{{ material.materialCode }}</div>
                    </div>
                    <!-- <div class="item-content" style="width: 14%;">
                      <v-textarea
                        v-model="material.brand"
                        label="品牌"
                        persistent-placeholder
                        variant="outlined"
                        density="compact"
                        hide-details="auto"
                        rows="1"
                        resize
                        auto-grow
                        class="auto-grow-textarea"
                      ></v-textarea>
                    </div> -->
                    <!-- :rules="[v => !!v || '必填', v => v > 0 || '须大于0']" -->
                    <div class="item-content" style="width: 8%;">
                      <v-text-field
                        v-model="material.materialCount"
                        label="数量"
                        persistent-placeholder
                        variant="outlined"
                        density="compact"
                        hide-details="auto"
                        type="number"
                        @input="handlePurchaseOrderQuantityInput(material, index)"
                      />
                    </div>
                    <div class="item-content" style="width: 80px;">
                      <v-text-field
                        v-model="material.materialUnit"
                        label="单位"
                        persistent-placeholder
                        variant="outlined"
                        density="compact"
                        hide-details
                        type="text"
                        class="v-field--readonly"
                        readonly
                      />
                    </div>
                    <div class="item-content" style="width: 43%;">
                      <v-textarea
                        v-model="material.remark"
                        label="物料备注"
                        persistent-placeholder
                        variant="outlined"
                        density="compact"
                        hide-details
                        rows="1"
                        resize
                        auto-grow
                      ></v-textarea>
                    </div>
                    <!-- :rules="[v => !!v?.warehouseNo || '请选择仓库']" -->
                    <!-- <div class="item-content" style="width: 15%;">
                      <v-select
                        v-model="material.warehouse"
                        :items="warehouseListOptions"
                        item-title="warehouseName"
                        item-value="warehouseNo"
                        label="送货地址"
                        placeholder="请选择送货地址"
                        persistent-placeholder
                        variant="outlined"
                        density="compact"
                        hide-details="auto"
                        return-object
                      >
                        <template v-slot:item="{ props, item }">
                          <v-list-item v-bind="{ ...props, title: undefined }">
                            <div>
                              <div class="text-body-2">{{ item.raw.warehouseName }}</div>
                              <div class="text-caption text-grey" v-if="item.raw.warehouseNo">地址: {{ item.raw.warehouseNo }}</div>
                            </div>
                          </v-list-item>
                        </template>
                      </v-select>
                    </div> -->
                    <div class="item-content" style="width: 16%; position: relative;">
                      <v-text-field
                        v-model="material.paymentDate"
                        label="计划交货"
                        persistent-placeholder
                        variant="outlined"
                        density="compact"
                        hide-details="auto"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        class="native-date-field"
                        @click="openMaterialDatePicker(index)"
                      />
                      <!-- 隐藏的原生日期输入框 
                        :rules="[v => !!v || '请选择日期']"-->
                      <input
                        :ref="el => setMaterialDateInputRef(el, index)"
                        type="date"
                        :value="material.paymentDate"
                        :min="getTodayDate()"
                        style="position: absolute; left: 0; top: 100%; opacity: 0; pointer-events: none; width: 100%; height: 1px; z-index: 9999;"
                        @change="(e) => onMaterialDateChange(e, index)"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </v-form>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn
              color="error"
              variant="tonal"
              @click="closePurchaseOrderDialog"
            >
              取消
            </v-btn>
            <v-btn
              color="primary"
              variant="flat"
              @click="submitPurchaseOrder"
              :loading="purchaseOrderLoading"
            >
              确定
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, watch, onMounted } from 'vue'
import { useSnackbar } from '@/composables/useSnackbar'
import { contractApi, purchaseApi, goodsManageApi } from '@/services/api'
import { bigClassOptions, getMaterialTypeOptions, materialUnitOptions } from '@/constants/contract'
import { useUserStore } from '@/stores/user'
import UploadImgDialog from '@/components/UploadImgDialog.vue'
import ImportExcel from '@/components/ImportMaterialExcel.vue'

interface Material {
  id?: number
  materialName: string
  materialCode?: string
  specDesc?: string
  remark?: string
  materialRemark?: string
  materialUnit?: string
  bigClass?: string
  materialType?: string
  materialPrice?: number
  materialImageUrls?: string
}

interface SearchForm {
  keyword: string
}

const { showSuccess, showError } = useSnackbar()
const userStore = useUserStore()

// 表格列配置
const headers = [
  { title: '编码', key: 'materialCode', align: 'center', width: '100px' },
  { title: '物料名称', key: 'materialName', align: 'center', width: '200px' },
  { title: '规格', key: 'specDesc', align: 'center', width: '160px' },
  { title: '备注', key: 'remark', align: 'center', width: '200px' },
  { title: '单位', key: 'materialUnit', align: 'center', width: '100px' },
  { title: '大类', key: 'bigClass', align: 'center', width: '120px' },
  { title: '小类', key: 'materialType', align: 'center', width: '120px' },
  { title: '操作', key: 'action', align: 'center', width: '160px' }
]


// 响应式数据
const loading = ref(false)
const currentPage = ref(1)
const pageSize = ref(30)
const total = ref(0)
const materialList = ref<Material[]>([])
const materialNameList = ref<Material[]>([])
const searchForm = ref<SearchForm>({
  keyword: ''
})

// 计算属性
const totalPages = computed(() => Math.ceil(total.value / pageSize.value))

// 新增物料相关状态
const showAddDialog = ref(false)
const addForm = ref()
const addFormValid = ref(false)
const addLoading = ref(false)
const newMaterial = ref<Material>({
  materialName: '',
  specDesc: '',
  remark: '',
  materialUnit: '',
  bigClass: '',
  materialType: ''
})

// 自定义物料相关变量
const showUploadDialog = ref(false)
const customMaterialImageUrls = ref<{ url: string; name: string }[]>([])
const customMaterialName = ref('')
const customMaterialSpecDesc = ref('')
const customMaterialBigClass = ref('')
const customMaterialType = ref('')
const customMaterialPrice = ref<number | null>(null)
const customMaterialUnit = ref('')
const customMaterialRemark = ref('')
// 编辑物料相关
const editingMaterialId = ref<number | null>(null)
const isEditMode = ref(false)
// 多选请购相关
const isSelectMode = ref(false)
const selectedMaterials = ref<Material[]>([])
// 删除相关状态
const deleteDialog = ref(false)
const deleteLoading = ref(false)
const selectedMaterial = ref<Material | null>(null)
const selectedIndex = ref(-1)

const importExcelDialogOpen = ref(false)
const importExcelTypeKind = ref(1)
const showCommonLoading = ref(false)
const commonLoadingText = ref('')

// 请购弹窗相关变量
interface WarehouseItemOptions {
  warehouseNo: string
  warehouseName: string
  warehouseAddress: string
}

const showPurchaseOrderDialog = ref(false)
const purchaseOrderForm = ref()
const purchaseOrderValid = ref(false)
const purchaseOrderLoading = ref(false)
const purchaseOrderMaterials = ref<any[]>([])  // 请购物料列表
const materialDateInputRefs = ref<Record<number, HTMLInputElement | null>>({})  // 存储每个物料的日期输入框引用
const purchaseOrderData = ref({
  id: null as number | null,
  contractNo: '', // 合同号
  warehouse: null as any,
})
// const warehouseListOptions = ref<WarehouseItemOptions[]>([
//   { warehouseNo: '上海市闵行区北翟路1630弄51号', warehouseName: '三厂203' },
//   { warehouseNo: '江苏省昆山市盛晞路48号', warehouseName: '昆山一厂' },
//   { warehouseNo: '江苏省昆山市盛晞路28号', warehouseName: '昆山二厂' },
//   { warehouseNo: '江苏省苏州市昆山市昆山开发区三巷路108号', warehouseName: '三号厂房' }
// ])
// 防抖保存
let saveTimers: { [key: number]: number | null } = {}

const warehouseList = ref<WarehouseItemOptions[]>([])
// 格式化仓库名称
const formattedWarehouseList = computed(() => {
  return warehouseList.value.map(warehouse => ({
    ...warehouse,
    warehouseName: `${warehouse.warehouseName}`
  }))
})

// 获取仓库列表
const loadWarehouseList = async () => {
  try {
    const res = await goodsManageApi.getWarehouseList()
    if (res.code === 0) {
      warehouseList.value = res.data || []
    } else {
      warehouseList.value = []
    }
  } catch (error) {
    const err = error as Error
    warehouseList.value = []
  }
}

const debouncedSave = (item: Material, index: number) => {
  // 清除该索引对应的旧定时器
  if (saveTimers[index]) {
    clearTimeout(saveTimers[index])
  }
  
  // 设置新的定时器
  saveTimers[index] = setTimeout(() => {
    handleSave(item, index)
    saveTimers[index] = null
  }, 1000) as unknown as number
}

// 防抖加载物料名称列表
let materialNameTimer: number | null = null

const debouncedLoadMaterialNameList = () => {
  // 清除旧的定时器
  if (materialNameTimer) {
    clearTimeout(materialNameTimer)
  }
  
  // 设置新的定时器
  materialNameTimer = setTimeout(() => {
    loadMaterialNameList(customMaterialName.value)
    materialNameTimer = null
  }, 1000) as unknown as number
}

// 加载名称类似的物料列表
const loadMaterialNameList = async (materialName: string) => {
  try {
    const res = await contractApi.getProjectTypeList({
      page: 1, 
      pageSize: 30,
      materialName: materialName
    })
    if (res?.code === 0) {
      materialNameList.value = res.data.records || []
    }
  } catch (error) {
    console.error('获取名称类似的物料列表失败:', error)
  }
}

// 加载物料列表
const loadMaterialList = async () => {
  try {
    loading.value = true
    const res = await contractApi.getProjectTypeList({ 
      page: currentPage.value, 
      pageSize: pageSize.value,
      keyword: searchForm.value.keyword,
      invType: 0
    })
    if (res?.code === 0) {
      materialList.value = res.data.records || []
      total.value = res.data.total || 0
    }
  } catch (error) {
    console.error('获取物料列表失败:', error)
  } finally {
    loading.value = false
  }
}

// 保存物料
const handleSave = async (item: Material, index: number) => {
//   if (!item.id) {
    try {
      const res = await contractApi.addPresetMaterial({
        id: item.id,
        materialName: item.materialName,
        specDesc: item.specDesc,
        bigClass: item.bigClass,
        materialType: item.materialType,
        materialUnit: item.materialUnit,
        materialRemark: item.materialRemark
      })
      if (res.code === 0) {
        // 更新ID
        materialList.value[index].id = res.data.id
        // showSuccess('物料保存成功')
      } else {
        // showError(res.message || '保存失败')
      }
    } catch (error: any) {
      console.error('保存物料失败:', error)
      showError(error.message || '保存失败')
    }
//   }
}

// 导入物料
const importMaterial = () => {
  customMaterialName.value = ''
  customMaterialSpecDesc.value = ''
  customMaterialBigClass.value = ''
  customMaterialType.value = ''
  customMaterialPrice.value = null
  customMaterialImageUrls.value = []
  importExcelDialogOpen.value = true
}

// 下载物料模板
const downloadMaterial = () => {
  const url = 'https://avalon-1304177540.cos.ap-shanghai.myqcloud.com/client/jiangfeng/excel/%E7%89%A9%E6%96%99%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88.xlsx?t='+Date.now()
  const a = document.createElement('a')
  a.href = url
  a.download = '物料模板.xlsx'
  a.click()
}
// 处理导入开始
const handleImportStart = () => {
  importExcelDialogOpen.value = true
}

// 导入excel
const handleImportExcel = async (files: { url: string; name: string }[]) => {
  const excelUrl = files[0].url
  showCommonLoading.value = true
  commonLoadingText.value = '正在导入物料...'
  try {
    const res = await contractApi.importPresetMaterialExcel ({
      // id: Number(contractId.value),
      url: excelUrl,
      invType: 0
      // row: row,
      // type: type,
      // sheetIndexList: sheetIndexList
    })
    if(res?.code === 0){
      // 隐藏导入框
      importExcelDialogOpen.value = false
      showCommonLoading.value = false
      commonLoadingText.value = ''
      showSuccess(res.data || '导入成功')
      loadMaterialList()
      // 开始检查导入状态
      // findImportProductStatus()
      
      // handleImportStart()
      // if(message){
      //   showSuccess(message) 
      // }else{
      //   showSuccess('文档上传成功') 
      // }
    }else if(res?.code === -1){
      showError(res.message)
      showCommonLoading.value = false
      commonLoadingText.value = ''
    }else{
      showError(res.message || '导入失败，请检查表格是否符合规范')
      showCommonLoading.value = false
      commonLoadingText.value = ''
    }
  } catch (err) {
    showError(err.message || '导入失败，请检查表格是否符合规范')
    showCommonLoading.value = false
    commonLoadingText.value = ''
  }
}

// 处理大类变化
const handleChangeBigClass = (item: Material, index: number) => {
  item.materialType = ''
  debouncedSave(item, index)
}

// 方法
const handleSearch = () => {
  currentPage.value = 1
  loadMaterialList()
}

const handleReset = () => {
  searchForm.value = {
    keyword: ''
  }
  handleSearch()
}

const handleAdd = () => {
  showAddDialog.value = true
  isEditMode.value = false
  editingMaterialId.value = null
  materialNameList.value = []
  customMaterialName.value = ''
  customMaterialSpecDesc.value = ''
  customMaterialBigClass.value = ''
  customMaterialType.value = ''
  customMaterialPrice.value = null
  customMaterialImageUrls.value = []
  customMaterialUnit.value = ''
  customMaterialRemark.value = ''
}

// 编辑物料
const handleEdit = (item: Material) => {
  cancelSelectMode()
  showAddDialog.value = true
  isEditMode.value = true
  editingMaterialId.value = item.id || null
  materialNameList.value = []
  // 填充表单数据
  customMaterialName.value = item.materialName || ''
  customMaterialSpecDesc.value = item.specDesc || ''
  customMaterialBigClass.value = item.bigClass || ''
  customMaterialType.value = item.materialType || ''
  customMaterialUnit.value = item.materialUnit || ''
  customMaterialRemark.value = item.materialRemark || ''
  customMaterialPrice.value = item.materialPrice || null
  // 处理图片
  if (item.materialImageUrls) {
    try {
      customMaterialImageUrls.value = JSON.parse(item.materialImageUrls)
    } catch {
      customMaterialImageUrls.value = []
    }
  } else {
    customMaterialImageUrls.value = []
  }
}

// 关闭添加/编辑弹窗
const closeAddDialog = () => {
  showAddDialog.value = false
  isEditMode.value = false
  editingMaterialId.value = null
  customMaterialName.value = ''
  customMaterialSpecDesc.value = ''
  customMaterialBigClass.value = ''
  customMaterialType.value = ''
  customMaterialPrice.value = null
  customMaterialImageUrls.value = []
  customMaterialUnit.value = ''
  customMaterialRemark.value = ''
}

// 处理大类变化 - 自定义物料
const handleChangeCustomBigClass = () => {
  customMaterialType.value = ''
}

// 处理新增物料图上传
const handleNewImageUpload = () => {
  showUploadDialog.value = true
}

// 处理图片上传成功
const handleNewImageUploadSuccess = (urls: string[]) => {
  customMaterialImageUrls.value = urls.map(url => ({
    url,
    name: `物料图_${Date.now()}`
  }))
  showUploadDialog.value = false
}

// 添加/编辑物料到物料库
const handleAddMaterialToBank = async () => {
  if (customMaterialName.value == '' || customMaterialName.value == null) {
    showError('物料名称不能为空')
    return
  }
  if (customMaterialBigClass.value == '' || customMaterialBigClass.value == null) {
    showError('大类不能为空')
    return
  }
  if (customMaterialType.value == '' || customMaterialType.value == null) {
    showError('小类不能为空')
    return
  }
  if (customMaterialUnit.value == '' || customMaterialUnit.value == null) {
    showError('单位不能为空')
    return
  }
  if(customMaterialSpecDesc.value == '' || customMaterialSpecDesc.value == null) {
    showError('规格不能为空')
    return
  }
  try {
    const params: any = {
      materialName: customMaterialName.value,
      specDesc: customMaterialSpecDesc.value,
      bigClass: customMaterialBigClass.value,
      materialType: customMaterialType.value,
      materialRemark: customMaterialRemark.value,
      materialUnit: customMaterialUnit.value,
      materialImageUrls: customMaterialImageUrls.value.length > 0 ? JSON.stringify(customMaterialImageUrls.value) : '',
      invType: 0
    }
    if (isEditMode.value && editingMaterialId.value) {
      params.id = editingMaterialId.value
    }
    const res = await contractApi.addPresetMaterial(params)
    if (res?.code === 0) {
      showSuccess(isEditMode.value ? '编辑物料成功' : '添加物料成功')
      closeAddDialog()
      loadMaterialList()
    } else {
      showError(res?.message || (isEditMode.value ? '编辑失败' : '添加失败'))
    }
  } catch (error: any) {
    console.error(isEditMode.value ? '编辑物料失败:' : '添加物料失败:', error)
    showError(error.message || error.msg || (isEditMode.value ? '编辑失败' : '添加失败'))
  }
}

const handleDelete = (item: Material, index: number) => {
  cancelSelectMode()
  if(userStore.userInfo?.auths.includes('jf_goods')){
    selectedMaterial.value = item
    selectedIndex.value = index
    deleteDialog.value = true
  }else{
    showError('无权限删除')
    return
  }
}

// 多选相关计算属性
const isAllSelected = computed(() => {
  return materialList.value.length > 0 && selectedMaterials.value.length === materialList.value.length
})

const isIndeterminate = computed(() => {
  return selectedMaterials.value.length > 0 && selectedMaterials.value.length < materialList.value.length
})

// 检查物料是否被选中
const isSelected = (item: Material) => {
  return selectedMaterials.value.some(m => m.id === item.id)
}

// 切换单个物料选中状态
const toggleSelect = (item: Material) => {
  const index = selectedMaterials.value.findIndex(m => m.id === item.id)
  if (index > -1) {
    selectedMaterials.value.splice(index, 1)
  } else {
    // 最多只能选择10个物料
    if (selectedMaterials.value.length >= 10) {
      showError('最多只能选择10个物料')
      return
    }
    selectedMaterials.value.push(item)
  }
}

// 全选/取消全选
const toggleSelectAll = (value: boolean) => {
  if (value) {
    selectedMaterials.value = [...materialList.value]
  } else {
    selectedMaterials.value = []
  }
}

// 进入多选模式
const handlePurchaseOrder = () => {
  isSelectMode.value = true
  selectedMaterials.value = []
}

// 取消多选模式
const cancelSelectMode = () => {
  isSelectMode.value = false
  selectedMaterials.value = []
}

// 确认请购（多选）
const confirmPurchaseOrder = () => {
  if (selectedMaterials.value.length === 0) {
    showError('请至少选择一个物料')
    return
  }
  // 将选中的物料转换为请购物料格式
  purchaseOrderMaterials.value = selectedMaterials.value.map(item => ({
    id: item.id,
    materialName: item.materialName || '',
    materialCode: item.materialCode || '',
    specDesc: item.specDesc || '',
    materialUnit: item.materialUnit || '',
    materialCount: null,
    brand: '',
    remark: item.materialRemark,
    warehouse: null as any,
    paymentDate: '',
    materialType: item.materialType || '',
    bigClass: item.bigClass || '',
  }))
  purchaseOrderData.value = { id: null, contractNo: '', warehouse: null }
  materialDateInputRefs.value = {}
  cancelSelectMode()
  showPurchaseOrderDialog.value = true
}

// 打开请购弹窗（单个物料）
const handleCreatePurchaseOrder = (item: Material) => {
  // 将当前物料转换为物料详情格式
  purchaseOrderMaterials.value = [{
    id: item.id,
    materialName: item.materialName || '',
    materialCode: item.materialCode || '',
    specDesc: item.specDesc || '',
    materialUnit: item.materialUnit || '',
    materialCount: null, // 数量需要用户输入
    brand: '', // 品牌
    remark: item.materialRemark, // 采购备注
    warehouse: null as any, // 入库仓库
    paymentDate: '', // 计划交货日期
    materialType: item.materialType || '', // 物料类型
    bigClass: item.bigClass || '', // 大类
  }]
  purchaseOrderData.value = { id: null, contractNo: '', warehouse: null }
  materialDateInputRefs.value = {}
  showPurchaseOrderDialog.value = true
}

// 关闭请购弹窗
const closePurchaseOrderDialog = () => {
  showPurchaseOrderDialog.value = false
  purchaseOrderMaterials.value = []
  purchaseOrderData.value = { id: null, contractNo: '', warehouse: null }
  materialDateInputRefs.value = {}
  purchaseOrderForm.value?.reset()
}

// 获取今天的日期字符串（用于日期选择器的min属性）
const getTodayDate = () => {
  const today = new Date()
  const year = today.getFullYear()
  const month = String(today.getMonth() + 1).padStart(2, '0')
  const day = String(today.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

// 设置物料日期输入框引用
const setMaterialDateInputRef = (el: HTMLInputElement | null, index: number) => {
  if (el) {
    materialDateInputRefs.value[index] = el
  }
}

// 打开物料的日期选择器
const openMaterialDatePicker = (index: number) => {
  const input = materialDateInputRefs.value[index]
  if (input) {
    if (input.showPicker) {
      input.showPicker()
    } else {
      input.click()
    }
  }
}

// 物料日期选择变化处理
const onMaterialDateChange = (event: Event, index: number) => {
  const target = event.target as HTMLInputElement
  const newDate = target.value
  
  try {
    if (newDate && typeof newDate === 'string' && purchaseOrderMaterials.value[index]) {
      purchaseOrderMaterials.value[index].paymentDate = newDate
    }
  } catch (error) {
    console.error('物料日期处理失败:', error)
  }
}

// 处理请购数量输入
const handlePurchaseOrderQuantityInput = (material: any, index: number) => {
  let value = String(material.materialCount || '').trim()
  value = value.replace(/[^\d]/g, '')
  
  if (value === '') {
    material.materialCount = ''
    return
  }
  
  value = value.replace(/^0+(\d)/, '$1')
  const num = parseInt(value, 10)
  
  if (!isNaN(num) && num > 0) {
    material.materialCount = num
  } else {
    material.materialCount = ''
  }
}

// 提交请购
const submitPurchaseOrder = async () => {
  // 验证表单
  const { valid } = await purchaseOrderForm.value?.validate() || { valid: false }
  
  // 手动验证每个物料的必填项
  if(!purchaseOrderData.value.warehouse || !purchaseOrderData.value.warehouse.warehouseNo){
    showError('送货地址不能为空')
    return
  }
  const materials = purchaseOrderMaterials.value
  // for (let i = 0; i < materials.length; i++) {
  //   if(!materials[i].warehouse || !materials[i].warehouse.warehouseNo){
  //     showError('请选择送货地址')
  //     return
  //   }
  // }
  for (let i = 0; i < materials.length; i++) {
    if(!materials[i].materialUnit){
      showError('单位不能为空')
      return
    }
  }
  const materialList = materials.map(material => ({
    materialCode: material.materialCode,
    materialName: material.materialName,
    materialSpec: material.specDesc,
    brand: material.brand || '',
    quantity: material.materialCount,
    unit: material.materialUnit,
    remark: material.remark || '',
    // warehouseNo: material.warehouse?.warehouseNo || '',
    // warehouseName: material.warehouse?.warehouseName || '',
    plannedDeliveryDate: material.paymentDate || '',
  }))
  try {
    purchaseOrderLoading.value = true
    
    const submitData = {
      contractNo: purchaseOrderData.value.contractNo || '', // 合同号
      warehouseNo: purchaseOrderData.value.warehouse?.warehouseNo || '',
      warehouseName: purchaseOrderData.value.warehouse?.warehouseName || '',
      items: materialList,
    }
    const res = await purchaseApi.purchaseRequisitionAdd(submitData)
    if (res?.code === 0) {
      showSuccess(purchaseOrderData.value.id ? '请购单修改成功' : '请购单创建成功')
      closePurchaseOrderDialog()
    } else {
      showError(res?.message || res?.msg || '创建请购单失败')
    }
  } catch (error: any) {
    console.error('创建请购单失败:', error)
    showError(error.message || '创建请购单失败')
  } finally {
    purchaseOrderLoading.value = false
  }
}

const confirmDelete = async () => {
//   if (!selectedMaterial.value?.id) {
//     // 如果没有ID，说明是新增未保存的物料，直接从列表中移除
//     materialList.value.splice(selectedIndex.value, 1)
//     deleteDialog.value = false
//     selectedMaterial.value = null
//     selectedIndex.value = -1
//     return
//   }
  
  try {
    deleteLoading.value = true
    const res = await contractApi.deletePresetMaterial({
      id: selectedMaterial.value.id
    })
    if (res.code === 0) {
      showSuccess('删除成功')
      materialList.value.splice(selectedIndex.value, 1)
    //   loadMaterialList()
    } else {
      showError(res.message || '删除失败')
    }
    deleteDialog.value = false
  } catch (error: any) {
    showError(error.message || '删除失败')
  } finally {
    deleteLoading.value = false
    selectedMaterial.value = null
    selectedIndex.value = -1
  }
}

// 监听分页变化
watch([currentPage, pageSize], () => {
  window.scrollTo(0, 0)
  loadMaterialList()
})

// 初始化
onMounted(() => {
  loadMaterialList()
  loadWarehouseList()
})
</script>

<style scoped>
.search-input :deep(.mdi-magnify),
.search-input :deep(.mdi-magnify::before),
.search-input :deep(.mdi-close::before),
.search-input :deep(.mdi-close-circle),
.search-input :deep(.mdi-close) {
  color: #fff!important;
}

.material-library-page {
  min-height: 100vh;
  width: 100%;
  background-color: #2B2D33;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 16px;
}

.material-library-container {
  width: 100%;
  max-width: 1400px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.text-primary {
  color: #D2475D !important;
}

.search-card {
  background-color: #2B2D33 !important;
  border: none !important;
  position: relative;
  z-index: 20;
}

.search-card :deep(.v-text-field) .v-field__input,
.search-card :deep(.v-text-field) .v-field__field,
.search-card :deep(.v-text-field) input,
.search-card :deep(.v-text-field) .v-field__append-inner,
.search-card :deep(.v-select) .v-field__input,
.search-card :deep(.v-select) .v-field__field,
.search-card :deep(.v-select) input,
.search-card :deep(.v-select) .v-select__selection-text,
.search-card :deep(.v-select) .v-select__selection,
.search-card :deep(.v-select) .v-field__append-inner {
  color: #fff !important;
}

.search-card :deep(.v-text-field) .v-field__outline,
.search-card :deep(.v-select) .v-field__outline {
  color: rgba(255, 255, 255, 0.12) !important;
}

.search-card :deep(.v-text-field) .v-field__input::placeholder {
  color: rgba(255, 255, 255, 0.7) !important;
}

.search-card :deep(.v-text-field) .v-label,
.search-card :deep(.v-select) .v-label {
  color: rgba(255, 255, 255, 0.7) !important;
}

:deep(.v-card) {
  box-shadow: none !important;
  border: 1px solid rgba(255, 255, 255, 0.12) !important;
}

.table-card {
  background-color: #2B2D33 !important;
  flex: 1;
  display: flex;
  position: relative;
  z-index: 1;
}

.table-card :deep(.v-card-text) {
  padding: 16px;
}

.material-table {
  background-color: #2B2D33;
}

.material-table :deep(th) {
  background-color: #2B2D33 !important;
  color: rgba(255, 255, 255, 0.7) !important;
  font-weight: 500;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12) !important;
  padding: 12px 8px !important;
}

.material-table :deep(td) {
  color: #fff !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12) !important;
  padding: 8px !important;
}

.material-table :deep(tr:hover) {
  background-color: rgba(255, 255, 255, 0.05) !important;
}

.material-table :deep(.v-text-field) .v-field__input,
.material-table :deep(.v-text-field) .v-field__field,
.material-table :deep(.v-text-field) input,
.material-table :deep(.v-textarea) .v-field__input,
.material-table :deep(.v-textarea) .v-field__field,
.material-table :deep(.v-textarea) textarea,
.material-table :deep(.v-select) .v-field__input,
.material-table :deep(.v-select) .v-field__field,
.material-table :deep(.v-select) input,
.material-table :deep(.v-select) .v-select__selection-text,
.material-table :deep(.v-select) .v-select__selection {
  color: #fff !important;
}

.material-table :deep(.v-text-field) .v-field__outline,
.material-table :deep(.v-textarea) .v-field__outline,
.material-table :deep(.v-select) .v-field__outline {
  color: rgba(255, 255, 255, 0.12) !important;
}

.custom-pagination {
  padding: 16px;
  color: rgba(255, 255, 255, 0.7);
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}

.custom-pagination .pagination-info {
  font-size: 14px;
}

.custom-pagination .pagination-controls {
  display: flex;
  align-items: center;
}

.custom-pagination .pagination-btn {
  color: rgba(255, 255, 255, 0.7) !important;
}

.custom-pagination .pagination-btn:hover {
  color: #fff !important;
}

.custom-pagination .pagination-btn:disabled {
  color: rgba(255, 255, 255, 0.3) !important;
}

.custom-pagination .pagination-text {
  font-size: 14px;
}

.search-input {
  width: 100%;
}

.gap-2 {
  gap: 8px;
}

.search-btn {
  font-weight: 400;
  text-transform: none;
  letter-spacing: 0;
  font-size: 14px;
  padding: 0 16px;
  min-width: unset;
}

.delete-dialog {
  background-color: #2B2D33 !important;
}

.delete-dialog :deep(.v-card-title) {
  color: #fff !important;
}

.delete-dialog :deep(.v-card-text) {
  color: rgba(255, 255, 255, 0.7) !important;
}

.delete-dialog :deep(.v-btn) {
  text-transform: none;
  letter-spacing: 0;
}

:deep(th),:deep(td) {
  padding: 8px !important;
}

.no-img {
  background-color: rgba(0, 0, 0, 0.5);
  color: rgba(255, 255, 255, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  text-align: center;
  border-radius: 4px;
}

.img-icon-one {
  width: 32px;
  height: 32px;
  opacity: 0.5;
}

.material-image {
  display: block;
  margin: 0 auto;
  object-fit: cover;
}

.correlate-btn {
  width: 100%;
  justify-content: flex-end;
  gap: 10px;
  padding: 0 16px 16px;
}

.delete-confirm-dialog {
  background-color: #2B2D33 !important;
}

.delete-confirm-dialog :deep(.v-card-title) {
  color: #fff !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  padding: 16px;
}

.delete-confirm-dialog :deep(.v-card-text) {
  color: rgba(255, 255, 255, 0.7) !important;
  padding: 24px 16px;
}

.delete-confirm-dialog :deep(.v-text-field) .v-field__input,
.delete-confirm-dialog :deep(.v-text-field) .v-field__field,
.delete-confirm-dialog :deep(.v-text-field) input,
.delete-confirm-dialog :deep(.v-textarea) .v-field__input,
.delete-confirm-dialog :deep(.v-textarea) .v-field__field,
.delete-confirm-dialog :deep(.v-textarea) textarea,
.delete-confirm-dialog :deep(.v-select) .v-field__input,
.delete-confirm-dialog :deep(.v-select) .v-field__field,
.delete-confirm-dialog :deep(.v-select) input,
.delete-confirm-dialog :deep(.v-select) .v-select__selection-text,
.delete-confirm-dialog :deep(.v-select) .v-select__selection {
  color: #fff !important;
}

.delete-confirm-dialog :deep(.v-text-field) .v-field__outline,
.delete-confirm-dialog :deep(.v-textarea) .v-field__outline,
.delete-confirm-dialog :deep(.v-select) .v-field__outline {
  color: rgba(255, 255, 255, 0.12) !important;
}

.delete-confirm-dialog :deep(.v-text-field) .v-label,
.delete-confirm-dialog :deep(.v-textarea) .v-label,
.delete-confirm-dialog :deep(.v-select) .v-label {
  color: rgba(255, 255, 255, 0.7) !important;
}

.delete-confirm-dialog :deep(.v-btn) {
  text-transform: none;
  letter-spacing: 0;
}

:deep(.v-list-item__content) {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

:deep(.material-name-list)::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

:deep(.material-name-list)::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 3px;
}

:deep(.material-name-list)::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 3px;
}

:deep(.material-name-list)::-webkit-scrollbar-thumb:hover {
  background-color: rgba(255, 255, 255, 0.4);
}

.common-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.common-loading-container {
  text-align: center;
  color: #fff;
}

.common-loading-spinner {
  border: 4px solid #2B2D33;
  border-top: 4px solid #D2475D;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin: 0 auto;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.common-loading-text {
  margin-top: 16px;
  font-size: 14px;
}

:deep(.mdi:before, .mdi-set){
    color: #FFFFFF;
}
/* 全局样式 - 送货地址下拉菜单（白底样式） */
.warehouse-select-menu .v-list-item .v-list-item__content {
  display: block !important;
}

.warehouse-select-menu .v-list-item .v-list-item-title {
  display: block;
  width: 100%;
}

.warehouse-select-menu .v-list-item .v-list-item-subtitle {
  display: block;
  width: 100%;
  margin-top: 4px;
  white-space: normal;
  -webkit-line-clamp: unset;
}

/* 采购对话框样式 */
.purchase-dialog {
  background-color: #2B2D33 !important;
}

.purchase-dialog :deep(.v-card-title) {
  color: #fff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  padding: 16px 24px;
  font-size: 18px;
  font-weight: 500;
}

.purchase-dialog :deep(.v-card-text) {
  padding: 24px;
}

.purchase-dialog :deep(.v-card-actions) {
  padding: 16px 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}

.purchase-dialog :deep(.v-autocomplete .v-field__input),
.purchase-dialog :deep(.v-text-field .v-field__input),
.purchase-dialog :deep(.v-autocomplete input),
.purchase-dialog :deep(.v-text-field input),
.purchase-dialog :deep(.v-textarea .v-field__input),
.purchase-dialog :deep(.v-textarea textarea) {
  color: #fff !important;
}

.purchase-dialog :deep(.v-autocomplete .v-field__outline),
.purchase-dialog :deep(.v-text-field .v-field__outline),
.purchase-dialog :deep(.v-textarea .v-field__outline) {
  color: rgba(255, 255, 255, 0.12) !important;
}

.purchase-dialog :deep(.v-autocomplete .v-field__input::placeholder),
.purchase-dialog :deep(.v-text-field .v-field__input::placeholder),
.purchase-dialog :deep(.v-textarea .v-field__input::placeholder) {
  color: rgba(255, 255, 255, 0.5) !important;
}

.purchase-dialog :deep(.v-label) {
  color: rgba(255, 255, 255, 0.7) !important;
}

.purchase-dialog :deep(.v-autocomplete .v-field__append-inner i),
.purchase-dialog :deep(.v-text-field .v-field__append-inner i) {
  color: rgba(255, 255, 255, 0.7) !important;
}

.purchase-dialog :deep(.v-list) {
  background-color: #2B2D33 !important;
}

.purchase-dialog :deep(.v-list-item) {
  color: #fff !important;
}

.purchase-dialog :deep(.v-list-item:hover) {
  background-color: rgba(255, 255, 255, 0.08) !important;
}

.purchase-dialog :deep(.v-list-item-title) {
  color: #fff !important;
}

.purchase-dialog :deep(.v-list-item-subtitle) {
  color: rgba(255, 255, 255, 0.6) !important;
}

.purchase-dialog :deep(.v-select .v-field__input),
.purchase-dialog :deep(.v-select .v-field__field),
.purchase-dialog :deep(.v-select input),
.purchase-dialog :deep(.v-select .v-select__selection-text),
.purchase-dialog :deep(.v-select .v-select__selection),
.purchase-dialog :deep(.v-select .v-field__append-inner) {
  color: #fff !important;
}

.purchase-dialog :deep(.v-select .v-field__outline) {
  color: rgba(255, 255, 255, 0.12) !important;
}

.purchase-dialog :deep(.v-select .v-field__append-inner i) {
  color: rgba(255, 255, 255, 0.7) !important;
}

.purchase-dialog :deep(.v-messages__message) {
  color: #ff5252 !important;
}

/* 隐藏数字输入框的箭头 */
.purchase-dialog :deep(input[type="number"])::-webkit-inner-spin-button,
.purchase-dialog :deep(input[type="number"])::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.purchase-dialog :deep(input[type="number"]) {
  -moz-appearance: textfield;
}

.purchase-dialog :deep(.mdi) {
  color: #fff !important;
}

/* 物料采购列表样式 */
.material-purchase-list {
  margin: 20px 0;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 4px;
  overflow: hidden;
}

/* 请购表头样式 */
.material-purchase-header {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  background-color: rgba(255, 255, 255, 0.05);
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}

.material-purchase-header .header-item {
  color: rgba(255, 255, 255, 0.7);
  font-size: 13px;
  font-weight: 500;
  text-align: center;
  padding: 0 8px;
}

.material-purchase-header .header-item .required-mark {
  color: #ff5252;
  margin-left: 2px;
}

.material-purchase-body {
  max-height: 400px;
  overflow-y: auto;
}

.material-purchase-item {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  transition: background-color 0.2s;
}

.material-purchase-item:hover {
  background-color: rgba(255, 255, 255, 0.03);
}

.material-purchase-item:last-child {
  border-bottom: none;
}

.material-purchase-item .item-content {
  color: #fff;
  font-size: 14px;
  text-align: center;
  padding: 0 4px;
}

.material-purchase-item .material-name {
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  text-align: left;
}

.material-purchase-item .material-spec {
  color: rgba(255, 255, 255, 0.7);
  font-size: 13px;
  text-align: left;
  margin-top: 2px;
}

.material-purchase-item .material-code {
  color: rgba(255, 255, 255, 0.6);
  font-size: 12px;
  text-align: left;
  margin-top: 4px;
}

/* 日期选择器字段样式 */
.native-date-field {
  cursor: pointer;
}

/* 只读字段样式 */
:deep(.v-field--readonly) {
  background-color: rgba(255, 255, 255, 0.05) !important;
}

:deep(.v-field--readonly .v-field__input) {
  color: rgba(255, 255, 255, 0.5) !important;
}

.form-actions {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
  background-color: rgba(43, 45, 51, 0.95);
  backdrop-filter: blur(8px);
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.2);
  z-index: 100;
}

.form-actions .v-btn {
  min-width: 120px;
}

:deep(.mdi-checkbox-blank-outline::before),:deep(.mdi-checkbox-marked::before){
  color: #D2475D !important;
  font-size: 18px !important; 
}
</style>

